import usePilotName from "../hooks/usePilotName";
import { useLens } from "../lens/LensProvider";
import { withoutPilotParam } from "../lens/lensState";

export default function LensTabs() {
  const { activeUid, setScope, pinnedUid, viewUid } = useLens();
  const viewingOther = !!viewUid && viewUid !== pinnedUid;
  const name = usePilotName(viewingOther ? viewUid : pinnedUid);
  if (!pinnedUid && !viewingOther) return null;

  if (viewingOther) {
    return <div className="lens-tabs" role="group" aria-label="Whose data is shown">
      <span className="lens-tabs-label">Viewing</span>
      <span className="lens-tab is-current" title={name}>{name}</span>
      <a className="lens-tab-link" href={withoutPilotParam(window.location.hash)}>{pinnedUid ? "Back to my view" : "Show everyone"}</a>
    </div>;
  }

  return <div className="lens-tabs" role="group" aria-label="Whose data is shown">
    <span className="lens-tabs-label">Showing</span>
    <button type="button" className="lens-tab" title={name} aria-pressed={!!activeUid} onClick={() => setScope("pilot")}>{name}</button>
    <button type="button" className="lens-tab" aria-pressed={!activeUid} onClick={() => setScope("everyone")}>Everyone</button>
  </div>;
}
